import { useState } from "react";
import { motion } from "motion/react";
import { Icon } from "swing-components";

import { MarkdownContent } from "~components";

type AccordionProps = {
  label: string;
  content: string;
};

export function Accordion(props: AccordionProps) {
  const { label, content } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <button
      onClick={() => setIsOpen(!isOpen)}
      css={{
        display: "flex",
        flexDirection: "column",
        transition: "gap 200ms",
        gap: !isOpen ? 0 : "var(--spacing-lg)",
        boxShadow: "var(--swing-box-shadow)",
        borderRadius: "var(--spacing-sm)",
        padding: "var(--spacing-lg)",
        background: "var(--swing-white300)",
        color: "var(--swing-black)",
        textAlign: "left",
      }}
    >
      <header
        css={{
          width: "100%",
          fontSize: "var(--swing-font-md)",
          fontWeight: "var(--swing-font-normal)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "var(--spacing-lg)",
        }}
      >
        {label}
        <motion.div
          initial={{ rotate: 0 }}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <Icon name="Chevron Down" />
        </motion.div>
      </header>
      <motion.hr
        css={{
          width: "100%",
          transformOrigin: "center",
          background: "var(--swing-slate300)",
          margin: 0,
          border: "none",
        }}
        initial={{ height: 0, opacity: 0, scaleX: 0 }}
        animate={{ height: isOpen ? 1 : 0, opacity: isOpen ? 1 : 0, scaleX: isOpen ? 1 : 0 }}
        transition={{ duration: 0.2 }}
      />
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
        transition={{ duration: 0.2 }}
        css={{
          width: "100%",
          overflow: "hidden",
        }}
        aria-expanded={isOpen}
      >
        <MarkdownContent body={content} />
      </motion.div>
    </button>
  );
}
